import { Button, UncontrolledTooltip } from 'reactstrap';
import { useTranslation } from 'react-i18next';

export const LeadsHeadingTooltip = () => {
  const { t } = useTranslation();
  return (
    <>
      {' '}
      <Button
        id={'leadsInfoButton'}
        size="lg"
        color="none"
        className="position-absolute heading-tooltip border-0"
        style={{
          bottom: '13px',
        }}
      >
        <i className="fa fa-question-circle text-muted"></i>
      </Button>
      <UncontrolledTooltip
        target={'leadsInfoButton'}
        placement="bottom-start"
        container="body"
        delay={{ show: 50, hide: 50 }}
        style={{
          minWidth: '300px',
          backgroundColor: 'var(--balance-profie-bg)',
        }}
      >
        <div className="d-flex flex-column text-start">
          <p className="p-0 m-0">
            <span className="f-w-700">{t('leads.headingTooltip.new')}:</span>{' '}
            {t('leads.headingTooltip.newDescr')}
          </p>

          {/* <p className="ps-2 pt-2 m-0 f-w-700">{t('leads.headingTooltip.subcats')}: </p> */}
          <ul
            className="mb-0 ps-4 pb-2 d-flex flex-column gap-1 border-top border-bottom"
            style={{
              listStyle: 'initial',
            }}
          >
            <li>{t('leads.headingTooltip.all')}</li>
            <li>{t('leads.headingTooltip.webinarInvitation')}</li>
            <li>{t('leads.headingTooltip.webinarTake')}</li>
            <li>{t('leads.headingTooltip.activity')}</li>
          </ul>

          <p className="p-0 m-0">
            <span className="f-w-700">{t('leads.headingTooltip.success')}:</span>{' '}
            {t('leads.headingTooltip.successDescr')}
          </p>
          <p className="p-0 m-0">
            <span className="f-w-700">{t('leads.headingTooltip.declined')}:</span>{' '}
            {t('leads.headingTooltip.declinedDescr')}
          </p>
        </div>
      </UncontrolledTooltip>
    </>
  );
};
